require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-dwo-j-1.json") })
        }
      }, "path---photos-professional-dwo-j-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-dwo-j-1!./.cache/json/photos-professional-dwo-j-1.json
// module id = 734
// module chunks = 231608221292675